var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoEmpty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 40985"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 14223",
    d: "M11.125 15.826a.542.542 0 1 1-.542-.549.545.545 0 0 1 .542.549zm0 0h-.542m5.958 0a.542.542 0 1 1-.541-.549.545.545 0 0 1 .542.549zm0 0H16m5.958 0a.542.542 0 1 1-.542-.549.545.545 0 0 1 .542.549zm0 0h-.542m7.583 0C29 22.495 23.179 27.9 16 27.9a13.929 13.929 0 0 1-3.691-.493 8.541 8.541 0 0 1-5.828 1.547q-.344-.034-.685-.1A6.594 6.594 0 0 0 7.209 25.9a2.03 2.03 0 0 0-.674-1.8A11.586 11.586 0 0 1 3 15.826C3 9.157 8.821 3.75 16 3.75s13 5.407 13 12.076z",
    transform: "translate(.5 -.25)",
    style: {
      fill: "none",
      stroke: "#645349",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEmpty);
export default __webpack_public_path__ + "viewer/static/media/ico-empty.cb502042098bd32bc645872a387b9c2d.svg";
export { ForwardRef as ReactComponent };